export async function fetchAppContent() {
  const url = 'https://appapi.petpaletteusa.com/app_api/v1/app_version/update_app_version';

  const formData = new FormData();
  formData.append('app_version', '1.0.0');
  formData.append('app_platform', 'android');
  formData.append('ln', 'en');

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjMsImlhdCI6MTc3MDM1MjI5NCwiZXhwIjoxNzcwNDM4Njk0LCJhdWQiOiJzdW5kYXktbW9ybmluZy11c2VycyIsImlzcyI6InN1bmRheS1tb3JuaW5nLWFwcCJ9.-tIQPgaFso4FoF5BBZehUI3emldt5isl81XyXUa4ggU'
    },
    body: formData
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message || 'Failed to fetch app content');
  }

  return result.data;
}
